<ng-container #componentOutlet></ng-container>